import React, { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import thumbimg from "../assets/images/thumbimg.png";
import TokenRegistrationTable from "../components/TokenRegistrationTable";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ApiLoader from "../components/ApiLoader";
import { interpretPcode } from "../utilities/interpretPcode";
import formatDateTime from "../utilities/formatDateTime";
const Scan = () => {
  const [bookMasterData, setBookMasterData] = useState([]);
  const [registrationYearMasterData, setRegistrationYearMasterData] = useState(
    []
  );
  const [
    scanningPropertyRegistrationList,
    setScanningPropertyRegistrationList,
  ] = useState([]);
  const [deviceDetails, setDeviceDetails] = useState({});

  const [selectedBookNo, setSelectedBookNo] = useState("");
  const [selectedRegYear, setSelectedRegYear] = useState("");
  const [registrationNo, setRegistrationNo] = useState("");
  const [scanVerified, setScanVerified] = useState(false);
  const [scanDocDetails, setScanDocDetails] = useState("");

  const [loading, setLoading] = useState(false);

  const { userDetails } = useSelector((state) => state.auth);
  console.log("user details", userDetails);

  const handleGetBookNoData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Master/book_no_master_data_get`
      );
      console.log("book master api response data", response.data);
      if (response.data?.statusResponse?.statusCode === 200) {
        setBookMasterData(response.data?.bookMasterList);
      } else {
        toast.error(response.data?.statusResponse?.status);
      }
    } catch (error) {
      console.log("book no api error", error);
      toast.error("An Unexpected Error Occured Please try Again");
    } finally {
      setLoading(false);
    }
  };

  const handleGetRegistrationYearData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Master/reg_year_master_data_get`
      );
      console.log("registration year api response data", response.data);
      if (response.data?.statusResponse?.statusCode === 200) {
        setRegistrationYearMasterData(response.data?.registrationYearMaster);
      } else {
        toast.error(response.data?.statusResponse?.status);
      }
    } catch (error) {
      console.log("registration year api error", error);
      toast.error("An Unexpected Error Occured Please try Again");
    } finally {
      setLoading(false);
    }
  };

  const handleGetScanningPropertyDetails = async () => {
    if (
      selectedBookNo.trim() !== "" &&
      selectedRegYear.trim() !== "" &&
      !isNaN(registrationNo) &&
      registrationNo.trim() !== ""
    ) {
      try {
        setLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/Registration/get_scanning_data_using_dcode_srocode_bookno_regno_regyear?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&bookno=${selectedBookNo}&regyear=${selectedRegYear}&regno=${registrationNo}`
        );
        console.log("scanning api response data", response.data);
        if (response.data?.statusResponse?.statusCode === 200) {
          setScanningPropertyRegistrationList(
            response.data?.scanningPropertyRegistrationList
          );
        } else {
          toast.error(response.data?.statusResponse?.status);
          setScanningPropertyRegistrationList([]);
        }
      } catch (error) {
        console.log("Scanning data api error", error);
        toast.error(
          "Failed to get Data due to unexpected error Please try Again"
        );
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please fill in all fields correctly.");
    }
  };

  debugger;

  const handleGetDeviceDetails = async () => {
    debugger;
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Master/get_device_details_using_dcode_srocode_devicetype?dcode=${userDetails?.dcode}&srocode=${userDetails?.srocode}&devicetype=SCANNER`
      );
      console.log("device api response data", response.data);
      if (response.data?.statusResponse?.statusCode === 200) {
        setDeviceDetails(response.data?.deviceDetails);
      } else {
        toast.error(response.data?.statusResponse?.status);
      }
    } catch (error) {
      console.log("devie api error", error);
      toast.error("Failed to Get Device Details due to Unexpected Error");
    }
  };
  console.log("DEVICE DETAILSSS:", deviceDetails);

  const handleActivateScanner = () => {
    try {
      window.location.href = "scanner://";
    } catch (error) {
      console.error("Error activating scanner", error);
      toast.error("Failed to activate scanner");
    }
  };

  // const handleVerifyScan = async () => {
  //   try {
  //     window.location.href = "openscan://";
  //     toast.success("Document opened successfully");
  //     setScanVerified(true);
  //   } catch (error) {
  //     console.error("Error opening scanned document", error);
  //     toast.error("Failed to open scanned document");
  //   }
  // };

  const handleVerifyScan = async () => {
    try {
      const response = await fetch(
        "http://localhost:5000/api/UploadScan/CheckScanExists"
      ); // change port if needed

      const data = await response.json();

      if (data.exists) {
        window.location.href = "openscan://";
        toast.success("Document opened successfully");
        setScanVerified(true);
      } else {
        toast.error("Scanned document not found");
      }
    } catch (error) {
      console.error("Error verifying scanned document", error);
      toast.error("Failed to verify scanned document");
    }
  };

  // const handleSaveDoc = async () => {
  //   const scanDocPath = deviceDetails?.deviceOperation;
  //   try {
  //     const response = await axios.get(
  //       `${API_BASE_URL}/ScanDocument/GetScannedRegistration?dcode=${userDetails?.dcode}&srocode=${userDetails?.srocode}&bookno=${selectedBookNo}&regyear=${selectedRegYear}&regno=${registrationNo}`
  //     );
  //     debugger;
  //     if (response.status === 200) {
  //       const { booknos, countScan, regdate, regnos, regyears } =
  //         response.data[0];

  //       const saveResponse = await axios.post(
  //         `${API_BASE_URL}/ScanDocument/SaveScannedDocument`,
  //         {
  //           dcode: userDetails?.dcode,
  //           srocode: userDetails?.srocode,
  //           bookno: booknos,
  //           regno: regnos,
  //           regyear: regyears,
  //           regdate: regdate,
  //           countScan: countScan,
  //           scanDocPath: scanDocPath,
  //           userid: userDetails?.email,
  //         }
  //       );
  //       debugger;
  //       if (saveResponse.data?.statusResponse?.statusCode === 200) {
  //         toast.success("Scanned document saved successfully!");

  //         setSelectedBookNo("");
  //         setSelectedRegYear("");
  //         setRegistrationNo("");
  //         setScanVerified(false);
  //         setScanDocDetails("");
  //         setScanningPropertyRegistrationList([]);
  //         // setTimeout(() => {
  //         //   window.location.reload();
  //         // }, 1000);
  //       } else {
  //         toast.error(
  //           saveResponse.data?.statusResponse?.status || "Save failed."
  //         );
  //       }
  //     } else {
  //       toast.error(
  //         response.data?.statusResponse?.status ||
  //           "Failed to fetch scan details."
  //       );
  //     }
  //   } catch (error) {
  //     debugger;
  //     if (error?.status === 409) {
  //       toast.error("Document already exists");
  //     } else {
  //       console.error("Error saving scanned document:", error);
  //       toast.error("An unexpected error occurred while saving the document.");
  //     }
  //   }
  // };

  // with window service starts

  const handleSaveDoc = async () => {
    const scanDocPath = deviceDetails?.deviceOperation;
    if (!scanDocPath) {
      toast.error("Scan document path is missing.");
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/ScanDocument/GetScannedRegistration?dcode=${userDetails?.dcode}&srocode=${userDetails?.srocode}&bookno=${selectedBookNo}&regyear=${selectedRegYear}&regno=${registrationNo}`
      );

      console.log("Scan Document Response:", response.data);

      if (response.status === 200 && response.data.length > 0) {
        const { booknos, countScan, regdate, regnos, regyears } =
          response.data[0];

        // dcode: userDetails?.dcode,
        //   srocode: userDetails?.srocode,
        //   bookno: booknos,
        //   regno: regnos,
        //   regyear: regyears,
        //   regdate: regdate,
        //   countScan: countScan,
        //   scanDocPath: scanDocPath,
        //   userid: userDetails?.email,

        // Call local Windows Service to upload the scan to server
        await axios.post(
          "http://localhost:5000/api/UploadScan/SaveScannedDocument",
          {
            scanDocPath,
            regdate,
            regyear: regyears,
            dcode: userDetails.dcode,
            srocode: userDetails.srocode,
            bookno: selectedBookNo,
            regno: parseInt(registrationNo),
            countScan: countScan,
            userid: userDetails?.email,
          }
        );

        toast.success("Document uploaded to server.");
      } else {
        toast.error("No scanned document found.");
      }
    } catch (err) {
      if (err.code === "ECONNREFUSED") {
        toast.error(
          "Scanner service not running. Please start the scanner service."
        );
      } else {
        toast.error("Failed to save scanned document.");
      }
      console.error(err);
    }
  };

  // with window service ends

  useEffect(() => {
    handleGetBookNoData();
    handleGetRegistrationYearData();
    handleGetDeviceDetails();
  }, []);

  return (
    <>
      {loading && <ApiLoader />}
      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            {/* Left Side */}
            <div className="flex-1 p-4">
              <div className="flex flex-col items-center p-6 bg-gray-100 min-h-screen">
                {/* Top section with dropdowns and buttons */}
                <div className="w-full max-w-3xl flex justify-between items-center mb-6">
                  <select
                    onChange={(e) => {
                      setSelectedBookNo(e.target.value);
                    }}
                    className="border border-gray-300 rounded px-3 py-2"
                    defaultValue={""}
                  >
                    <option value="" disabled>
                      Select Bookno.
                    </option>
                    {bookMasterData.length > 0 &&
                      bookMasterData.map((items, index) => (
                        <option key={index} value={items.bookNo}>
                          {items.bookNo}
                        </option>
                      ))}
                  </select>

                  <select
                    onChange={(e) => {
                      setSelectedRegYear(e.target.value);
                    }}
                    className="border border-gray-300 rounded px-3 py-2"
                    defaultValue={""}
                  >
                    <option value="" disabled>
                      Select Regyear
                    </option>
                    {registrationYearMasterData.length > 0 &&
                      registrationYearMasterData.map((items, index) => (
                        <option key={index} value={items.regYear}>
                          {items.regYear}
                        </option>
                      ))}
                  </select>
                  <p>Regno:</p>
                  <input
                    type="number"
                    name="registrationNo"
                    value={registrationNo}
                    onChange={(e) => {
                      setRegistrationNo(e.target.value);
                    }}
                    placeholder="Input"
                    className="border border-gray-300 rounded px-3 py-1"
                  />
                  <button
                    className="bg-blue-500 text-white rounded px-4 py-1"
                    onClick={handleGetScanningPropertyDetails}
                  >
                    Get Data
                  </button>
                  <button className="bg-blue-500 text-white rounded px-4 py-1">
                    Cancel
                  </button>
                </div>

                {/* Information Section */}
                {scanningPropertyRegistrationList.length > 0 && (
                  <div className="w-full max-w-3xl bg-white rounded-2xl border-2 border-secondary-600 p-6">
                    <div className="grid grid-cols-2 gap-8 text-left">
                      {/* Left Column */}
                      <div className="space-y-4">
                        <div className="flex p-1 ">
                          <p className="w-40 font-semibold">
                            Registration Date:
                          </p>
                          <span className="">
                            {formatDateTime(
                              scanningPropertyRegistrationList[0]?.regDate
                            )}
                          </span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">Market Value:</p>
                          <span className="">
                            {scanningPropertyRegistrationList[0]?.mValue}
                          </span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">
                            Transaction Value:
                          </p>
                          <span className="">
                            {scanningPropertyRegistrationList[0]?.transValue}
                          </span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">Pages:</p>
                          <span className="">
                            {scanningPropertyRegistrationList[0]?.page}
                          </span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">E.P. Fee:</p>
                          <span className="">
                            {scanningPropertyRegistrationList[0]?.pasting}
                          </span>
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4">
                        {scanningPropertyRegistrationList.length > 0 &&
                          scanningPropertyRegistrationList.map(
                            (items, index) => (
                              <div key={index} className="flex p-1">
                                <p className="w-40 font-semibold">
                                  {interpretPcode(items.pcode)}{" "}
                                </p>
                                <span className=""> {items.nameEng} </span>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  </div>
                )}
                {/* Footer Button */}
                {scanningPropertyRegistrationList.length > 0 && (
                  <div className="mt-6">
                    <button
                      onClick={handleActivateScanner}
                      className="bg-blue-500 text-white rounded px-6 py-2 m-2"
                    >
                      Activate Scanner
                    </button>
                    {deviceDetails?.deviceOperation && (
                      <button
                        onClick={handleVerifyScan}
                        className="bg-blue-500 text-white rounded px-6 py-2 m-2"
                      >
                        Verify Scan
                      </button>
                    )}
                    {scanVerified && (
                      <button
                        onClick={handleSaveDoc}
                        className="bg-blue-500 text-white rounded px-6 py-2 m-2"
                      >
                        Save
                      </button>
                    )}
                    {/* {deviceDetails?.deviceOperation && (
                      <button
                        onClick={handleSaveDoc}
                        className="bg-blue-500 text-white rounded px-6 py-2 m-2"
                      >
                        Save
                      </button>
                    )} */}
                  </div>
                )}
              </div>
            </div>

            {/* Right Side */}
            <div className="w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Scan;

// import React, { useEffect, useState } from "react";
// import SideMenu from "../components/SideMenu";
// import Header from "../components/Header";
// import UserMenu from "../components/UserMenu";
// import thumbimg from "../assets/images/thumbimg.png";
// import TokenRegistrationTable from "../components/TokenRegistrationTable";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Radio,
//   RadioGroup,
//   FormControl,
//   FormLabel,
// } from "@mui/material";
// import axios from "axios";
// import API_BASE_URL from "../utilities/ApiConfig";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import ApiLoader from "../components/ApiLoader";
// import { interpretPcode } from "../utilities/interpretPcode";
// import formatDateTime from "../utilities/formatDateTime";
// const Scan = () => {
//   const [bookMasterData, setBookMasterData] = useState([]);
//   const [registrationYearMasterData, setRegistrationYearMasterData] = useState(
//     []
//   );
//   const [
//     scanningPropertyRegistrationList,
//     setScanningPropertyRegistrationList,
//   ] = useState([]);
//   const [deviceDetails, setDeviceDetails] = useState({});

//   const [selectedBookNo, setSelectedBookNo] = useState("");
//   const [selectedRegYear, setSelectedRegYear] = useState("");
//   const [registrationNo, setRegistrationNo] = useState("");
//   const [scanVerified, setScanVerified] = useState(false);
//   const [scanDocDetails, setScanDocDetails] = useState("");

//   const [loading, setLoading] = useState(false);

//   const { userDetails } = useSelector((state) => state.auth);
//   console.log("user details", userDetails);

//   const handleGetBookNoData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API_BASE_URL}/Master/book_no_master_data_get`
//       );
//       console.log("book master api response data", response.data);
//       if (response.data?.statusResponse?.statusCode === 200) {
//         setBookMasterData(response.data?.bookMasterList);
//       } else {
//         toast.error(response.data?.statusResponse?.status);
//       }
//     } catch (error) {
//       console.log("book no api error", error);
//       toast.error("An Unexpected Error Occured Please try Again");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetRegistrationYearData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API_BASE_URL}/Master/reg_year_master_data_get`
//       );
//       console.log("registration year api response data", response.data);
//       if (response.data?.statusResponse?.statusCode === 200) {
//         setRegistrationYearMasterData(response.data?.registrationYearMaster);
//       } else {
//         toast.error(response.data?.statusResponse?.status);
//       }
//     } catch (error) {
//       console.log("registration year api error", error);
//       toast.error("An Unexpected Error Occured Please try Again");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetScanningPropertyDetails = async () => {
//     if (
//       selectedBookNo.trim() !== "" &&
//       selectedRegYear.trim() !== "" &&
//       !isNaN(registrationNo) &&
//       registrationNo.trim() !== ""
//     ) {
//       try {
//         setLoading(true);
//         const response = await axios.get(
//           `${API_BASE_URL}/Registration/get_scanning_data_using_dcode_srocode_bookno_regno_regyear?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&bookno=${selectedBookNo}&regyear=${selectedRegYear}&regno=${registrationNo}`
//         );
//         console.log("scanning api response data", response.data);
//         if (response.data?.statusResponse?.statusCode === 200) {
//           setScanningPropertyRegistrationList(
//             response.data?.scanningPropertyRegistrationList
//           );
//         } else {
//           toast.error(response.data?.statusResponse?.status);
//           setScanningPropertyRegistrationList([]);
//         }
//       } catch (error) {
//         console.log("Scanning data api error", error);
//         toast.error(
//           "Failed to get Data due to unexpected error Please try Again"
//         );
//       } finally {
//         setLoading(false);
//       }
//     } else {
//       toast.error("Please fill in all fields correctly.");
//     }
//   };

//   debugger;

//   const handleGetDeviceDetails = async () => {
//     debugger;
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/Master/get_device_details_using_dcode_srocode_devicetype?dcode=${userDetails?.dcode}&srocode=${userDetails?.srocode}&devicetype=SCANNER`
//       );
//       console.log("device api response data", response.data);
//       if (response.data?.statusResponse?.statusCode === 200) {
//         setDeviceDetails(response.data?.deviceDetails);
//       } else {
//         toast.error(response.data?.statusResponse?.status);
//       }
//     } catch (error) {
//       console.log("devie api error", error);
//       toast.error("Failed to Get Device Details due to Unexpected Error");
//     }
//   };
//   console.log("DEVICE DETAILSSS:", deviceDetails);

//   const handleActivateScanner = async () => {
//     debugger;
//     const devicePath = deviceDetails?.deviceModelNo;

//     if (!devicePath) {
//       toast.error("Device path is missing.");
//       return;
//     }

//     try {
//       const response = await fetch(`${API_BASE_URL}/Master/launch-device`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(devicePath),
//       });

//       const result = await response.text();
//       if (response.ok) {
//         console.log("Scanner activated:", result);
//         toast.success("Scanner activated!");
//       } else {
//         console.error("Error activating scanner:", result);
//         toast.error("Failed to activate scanner.");
//       }
//     } catch (error) {
//       console.error("Request failed:", error);
//       toast.error("Failed to send request.");
//     }
//   };

//   const handleVerifyScan = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/Master/verify-scan`, {
//         method: "POST",
//       });

//       const result = await response.text();

//       if (response.ok) {
//         toast.success("Document opened successfully");
//         setScanVerified(true);
//       } else {
//         console.error("Error fetching scanned document:", result);
//         toast.error(result);
//       }
//     } catch (error) {
//       console.error("Request failed:", error);
//       toast.error("Failed to send request.");
//     }
//   };

//   const handleSaveDoc = async () => {
//     const scanDocPath = deviceDetails?.deviceOperation;
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/ScanDocument/GetScannedRegistration?dcode=${userDetails?.dcode}&srocode=${userDetails?.srocode}&bookno=${selectedBookNo}&regyear=${selectedRegYear}&regno=${registrationNo}`
//       );
//       debugger;
//       if (response.status === 200) {
//         const { booknos, countScan, regdate, regnos, regyears } =
//           response.data[0];

//         const saveResponse = await axios.post(
//           `${API_BASE_URL}/ScanDocument/SaveScannedDocument`,
//           {
//             dcode: userDetails?.dcode,
//             srocode: userDetails?.srocode,
//             bookno: booknos,
//             regno: regnos,
//             regyear: regyears,
//             regdate: regdate,
//             countScan: countScan,
//             scanDocPath: scanDocPath,
//             userid: userDetails?.email,
//           }
//         );
//         debugger;
//         if (saveResponse.data?.statusResponse?.statusCode === 200) {
//           toast.success("Scanned document saved successfully!");

//           setSelectedBookNo("");
//           setSelectedRegYear("");
//           setRegistrationNo("");
//           setScanVerified(false);
//           setScanDocDetails("");
//           setScanningPropertyRegistrationList([]);
//           // setTimeout(() => {
//           //   window.location.reload();
//           // }, 1000);
//         } else {
//           toast.error(
//             saveResponse.data?.statusResponse?.status || "Save failed."
//           );
//         }
//       } else {
//         toast.error(
//           response.data?.statusResponse?.status ||
//             "Failed to fetch scan details."
//         );
//       }
//     } catch (error) {
//       debugger;
//       if (error?.status === 409) {
//         toast.error("Document already exists");
//       } else {
//         console.error("Error saving scanned document:", error);
//         toast.error("An unexpected error occurred while saving the document.");
//       }
//     }
//   };

//   useEffect(() => {
//     handleGetBookNoData();
//     handleGetRegistrationYearData();
//     handleGetDeviceDetails();
//   }, []);

//   return (
//     <>
//       {loading && <ApiLoader />}
//       <div className="flex h-screen">
//         <SideMenu />
//         <div className="flex-1 flex flex-col">
//           <Header />
//           <div className="flex flex-1">
//             {/* Left Side */}
//             <div className="flex-1 p-4">
//               <div className="flex flex-col items-center p-6 bg-gray-100 min-h-screen">
//                 {/* Top section with dropdowns and buttons */}
//                 <div className="w-full max-w-3xl flex justify-between items-center mb-6">
//                   <select
//                     onChange={(e) => {
//                       setSelectedBookNo(e.target.value);
//                     }}
//                     className="border border-gray-300 rounded px-3 py-2"
//                     defaultValue={""}
//                   >
//                     <option value="" disabled>
//                       Select Bookno.
//                     </option>
//                     {bookMasterData.length > 0 &&
//                       bookMasterData.map((items, index) => (
//                         <option key={index} value={items.bookNo}>
//                           {items.bookNo}
//                         </option>
//                       ))}
//                   </select>

//                   <select
//                     onChange={(e) => {
//                       setSelectedRegYear(e.target.value);
//                     }}
//                     className="border border-gray-300 rounded px-3 py-2"
//                     defaultValue={""}
//                   >
//                     <option value="" disabled>
//                       Select Regyear
//                     </option>
//                     {registrationYearMasterData.length > 0 &&
//                       registrationYearMasterData.map((items, index) => (
//                         <option key={index} value={items.regYear}>
//                           {items.regYear}
//                         </option>
//                       ))}
//                   </select>
//                   <p>Regno:</p>
//                   <input
//                     type="number"
//                     name="registrationNo"
//                     value={registrationNo}
//                     onChange={(e) => {
//                       setRegistrationNo(e.target.value);
//                     }}
//                     placeholder="Input"
//                     className="border border-gray-300 rounded px-3 py-1"
//                   />
//                   <button
//                     className="bg-blue-500 text-white rounded px-4 py-1"
//                     onClick={handleGetScanningPropertyDetails}
//                   >
//                     Get Data
//                   </button>
//                   <button className="bg-blue-500 text-white rounded px-4 py-1">
//                     Cancel
//                   </button>
//                 </div>

//                 {/* Information Section */}
//                 {scanningPropertyRegistrationList.length > 0 && (
//                   <div className="w-full max-w-3xl bg-white rounded-2xl border-2 border-secondary-600 p-6">
//                     <div className="grid grid-cols-2 gap-8 text-left">
//                       {/* Left Column */}
//                       <div className="space-y-4">
//                         <div className="flex p-1 ">
//                           <p className="w-40 font-semibold">
//                             Registration Date:
//                           </p>
//                           <span className="">
//                             {formatDateTime(
//                               scanningPropertyRegistrationList[0]?.regDate
//                             )}
//                           </span>
//                         </div>
//                         <div className="flex p-1">
//                           <p className="w-40 font-semibold">Market Value:</p>
//                           <span className="">
//                             {scanningPropertyRegistrationList[0]?.mValue}
//                           </span>
//                         </div>
//                         <div className="flex p-1">
//                           <p className="w-40 font-semibold">
//                             Transaction Value:
//                           </p>
//                           <span className="">
//                             {scanningPropertyRegistrationList[0]?.transValue}
//                           </span>
//                         </div>
//                         <div className="flex p-1">
//                           <p className="w-40 font-semibold">Pages:</p>
//                           <span className="">
//                             {scanningPropertyRegistrationList[0]?.page}
//                           </span>
//                         </div>
//                         <div className="flex p-1">
//                           <p className="w-40 font-semibold">E.P. Fee:</p>
//                           <span className="">
//                             {scanningPropertyRegistrationList[0]?.pasting}
//                           </span>
//                         </div>
//                       </div>

//                       {/* Right Column */}
//                       <div className="space-y-4">
//                         {scanningPropertyRegistrationList.length > 0 &&
//                           scanningPropertyRegistrationList.map(
//                             (items, index) => (
//                               <div key={index} className="flex p-1">
//                                 <p className="w-40 font-semibold">
//                                   {interpretPcode(items.pcode)}{" "}
//                                 </p>
//                                 <span className=""> {items.nameEng} </span>
//                               </div>
//                             )
//                           )}
//                       </div>
//                     </div>
//                   </div>
//                 )}
//                 {/* Footer Button */}
//                 {scanningPropertyRegistrationList.length > 0 && (
//                   <div className="mt-6">
//                     <button
//                       onClick={handleActivateScanner}
//                       className="bg-blue-500 text-white rounded px-6 py-2 m-2"
//                     >
//                       Activate Scanner
//                     </button>
//                     {deviceDetails?.deviceOperation && (
//                       <button
//                         onClick={handleVerifyScan}
//                         className="bg-blue-500 text-white rounded px-6 py-2 m-2"
//                       >
//                         Verify Scan
//                       </button>
//                     )}
//                     {scanVerified && (
//                       <button
//                         onClick={handleSaveDoc}
//                         className="bg-blue-500 text-white rounded px-6 py-2 m-2"
//                       >
//                         Save
//                       </button>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Right Side */}
//             <div className="w-64 h-full">
//               <UserMenu />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Scan;
